// Mirrors dbo.payment_method seed data (1 On Terms, 2 Credit Card, 3 ACH Pull,
// 4 ACH Push, 5 Wire, 6 Net Cash) - stable, small reference table. The full list is
// still fetched live via OrdersDataService.getRefData({keys:['PaymentMethods']}) for
// dropdown options; this single ID is just for the ACH-specific UI branching that
// needs to recognize "this is an ACH Pull payment" without a text-name comparison.
export const ACH_PULL_PAYMENT_METHOD_ID = 3;
